import { cn } from '@/lib/utils';
import { epcToAscii } from '@/lib/epc';

interface EpcTextProps {
  /** The raw EPC as stored — the hex tag value. */
  value?: string | null;
  /** Applied to the wrapper (e.g. "text-xs" / "text-sm"). */
  className?: string;
}

/**
 * Renders an EPC as its hex value with the decoded ASCII beneath it (muted),
 * when the tag is printable ASCII. Keeps BOTH forms visible: the hex is the
 * real tag value, the ASCII is the human-readable label (e.g. "TPS000006511").
 * For binary/EPC-96 tags only the hex shows.
 */
export function EpcText({ value, className }: EpcTextProps) {
  if (!value) return <span className="text-muted-foreground">—</span>;
  const ascii = epcToAscii(value);
  return (
    <span className={cn('font-mono leading-tight', className)}>
      <span className="block">{value}</span>
      {ascii && ascii !== value && (
        <span className="block text-muted-foreground text-[0.85em]">{ascii}</span>
      )}
    </span>
  );
}
